<template>
  <fieldset class="mt-3">
    <div class="row mt-3">
      <div class="col-12">
        <div class="form-check form-switch">
          <input
            id="getintouch-toggle"
            v-model="getInTouch.status"
            class="form-check-input"
            type="checkbox"
            @change="$emit('toggleGetInTouch')"
          />
          <label class="form-check-label" for="getintouch-toggle"
            >Get In touch</label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col">
            <fieldset>
              <caption class="full-width">
                Title
              </caption>
              <div class="card">
                <div class="card-body">
                  <div class="form-group full-width">
                    <label>Text</label>
                    <textarea
                      class="form-control mt-2"
                      rows="6"
                      required
                      v-model="getInTouch.title"
                    ></textarea>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="col">
            <fieldset>
              <caption class="full-width">
                Description
              </caption>
              <div class="card">
                <div class="card-body">
                  <div class="form-group full-width">
                    <label>Text</label>
                    <textarea
                      class="form-control mt-2"
                      rows="6"
                      required
                      v-model="getInTouch.description"
                    ></textarea>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col">
            <fieldset>
              <caption class="full-width">
                Button One
              </caption>
              <div class="card">
                <div class="card-body">
                  <div class="form-group full-width">
                    <label>Text</label>
                    <input
                      type="text"
                      class="form-control mt-2"
                      required
                      v-model="getInTouch.btn_one.text"
                    />
                  </div>
                  <div class="form-group full-width mt-3">
                    <label>Url</label>
                    <input
                      type="text"
                      class="form-control mt-2"
                      required
                      v-model="getInTouch.btn_one.url"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="col">
            <fieldset>
              <caption class="full-width">
                Button Two
              </caption>
              <div class="card">
                <div class="card-body">
                  <div class="form-group full-width">
                    <label>Text</label>
                    <input
                      type="text"
                      class="form-control mt-2"
                      required
                      v-model="getInTouch.btn_two.text"
                    />
                  </div>
                  <div class="form-group full-width mt-3">
                    <label>Url</label>
                    <input
                      type="text"
                      class="form-control mt-2"
                      required
                      v-model="getInTouch.btn_two.url"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "GetInTouch",
  props: {
    getInTouchData: { type: Object }
  },
  data() {
    return {
      getInTouch: this.getInTouchData
    };
  },
  watch: {
    getInTouch: {
      handler(val) {
        this.$emit("update-getintouch", val);
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.card-footer-title {
  min-height: 285px;
}
.card-fixed {
  height: auto;
  max-height: 650px;
  overflow-y: auto;
}
.card-body {
  min-height: 250px;
}
.card-body-title {
  color: #6c757d;
  display: inline-block;
  margin-bottom: 10px;
}
.full-width {
  max-width: 100%;
  width: 100%;
  margin-top: 6px;
  margin-bottom: 6px;
}
.form-group {
  textarea {
    line-height: 20px;
  }
}
.form-switch {
  padding-left: 0;
  .form-check-input {
    margin: 0;
  }
  .form-check-label {
    cursor: pointer;
  }
}
</style>
